<template>
  <div
    ref="floatingBall"
    v-drag
    class="floating-ball"
    @mouseleave="listVisible=false"
    @mousemove="floatingBallMousemove"
  >
    <transition :name="transitionDirection">
      <div v-show="listVisible" ref="ballList" class="ball-list">
        <el-tooltip class="item" effect="dark" content="复制request_id" placement="left">
          <div class="ball" @click="copyRequestId">
            <i class="el-icon-document-copy" />
          </div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="用户问卷" placement="left">
          <div class="ball">
            <a href="https://wenjuan.feishu.cn/m/cfm?t=sTNovXV1xDxi-00nc" target="_blank" rel="noopener noreferrer">
              <i class="el-icon-tickets" />
            </a>
          </div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="操作指南" placement="left">
          <div class="ball">
            <router-link to="/guide">
              <i class="el-icon-notebook-1" />
            </router-link>
          </div>
        </el-tooltip>
        <el-tooltip class="item" effect="dark" content="更新日志" placement="left">
          <div class="ball">
            <router-link to="/changelog">
              <i class="el-icon-reading" />
            </router-link>
          </div>
        </el-tooltip>
      </div>
    </transition>
    <div
      class="ball show-list-btn"
      @click="toggleListVisible"
      @mouseenter="handleMouseEnterShowListBtn"
    >
      <i :class="listVisible ? 'el-icon-close' : 'el-icon-question'" />
    </div>

  </div>
</template>
<script>

export default {
  name: 'FloatingBall',
  directives: {
    drag(el) {
      const oDiv = el // 当前元素
      oDiv.onmousedown = (e) => {
        // 鼠标按下，计算当前元素距离可视区的距离
        const disX = e.clientX - oDiv.offsetLeft
        const disY = e.clientY - oDiv.offsetTop
        const bottomHeight = oDiv.clientHeight / 2 + 18

        document.onmousemove = (e) => {
          let left = e.clientX - disX
          let top = e.clientY - disY
          const documentElement = document.documentElement
          const sideBarWidth = documentElement.clientWidth - document.getElementById('app-main').clientWidth
          if (left <= sideBarWidth) {
            left = sideBarWidth
          } else if (left >= documentElement.clientWidth - oDiv.clientWidth) {
            // 屏幕的可视宽度
            left = documentElement.clientWidth - oDiv.clientWidth
          }
          if (top <= 0) {
            top = 0
          } else if (top >= documentElement.clientHeight - bottomHeight) {
            // 屏幕的可视高度
            top = documentElement.clientHeight - bottomHeight
          }

          oDiv.style.left = left + 'px'
          oDiv.style.top = top + 'px'
        }
        document.onmouseup = () => {
          document.onmousemove = null
          document.onmouseup = null
        }
        return false
      }
    }
  },
  data() {
    return {
      listVisible: false,
      floatingBallHeight: '100px',
      transitionDirection: 'el-zoom-in-bottom'
    }
  },
  computed: {
    countFloatingBallHeight() {
      return this.listVisible ? this.floatingBallHeight : 0
    }
  },
  mounted() {
    this.getFloatingBallHeight()
    window.addEventListener('resize', this.getFloatingBallHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.getFloatingBallHeight)
  },
  methods: {
    toggleListVisible() {
      this.listVisible = !this.listVisible
    },
    mousedowm(e) { // 鼠标按下时的鼠标所在的X，Y坐标
      this.mouseDownX = e.pageX
      this.mouseDownY = e.pageY
    },
    getFloatingBallHeight() {
      this.listVisible = false
      this.floatingBallHeight = (document.getElementsByClassName('ball').length * 2 - 1) * 50 - 14

      this.countBallPosition()
      this.$nextTick(() => {
        this.$refs.floatingBall.style.top = `${document.documentElement.clientHeight - this.$refs.floatingBall.clientHeight / 2 - 50}px`
        this.$refs.floatingBall.style.right = '10px'
        this.$refs.floatingBall.style.left = 'auto'
      })
    },
    copyRequestId() {
      const route = window.location.hash.slice(1)
      const requestId = this.$store.getters.requestId[route].join('\r\n')
      this.copyLink(requestId)
    },
    countBallPosition() {
      this.transitionDirection = 'el-zoom-in-bottom'
      for (let i = 0; i < this.$refs.ballList.children.length; i++) {
        this.$refs.ballList.children[i].style.top = `${50 * i}px`
      }
    },
    floatingBallMousemove() {
      const floatingBall = this.$refs.floatingBall
      const offsetTop = this.$refs.ballList.children.length * 50
      if (floatingBall.offsetTop <= offsetTop) {
        this.transitionDirection = 'el-zoom-in-top'
      } else if (floatingBall.offsetTop >= offsetTop) {
        this.transitionDirection = 'el-zoom-in-bottom'
      }
      this.handleMouseEnterShowListBtn()
    },
    handleMouseEnterShowListBtn() {
      let top = 36
      if (this.transitionDirection === 'el-zoom-in-bottom') {
        top = -(this.$refs.ballList.children.length * 50 + 14)
      }
      this.$refs.ballList.style.top = `${top}px`
      this.listVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.floating-ball{
    position: fixed;
    right: 10px;
    top: 76%;
    z-index: 99999;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    .show-list-btn{
      position: absolute;
      bottom: 50%;
      margin: 0 !important;
      top: 0;
      right: 0;
      color: #444444;
    }
    .ball{
      display: flex;
      align-items: center;
      justify-content: center;
      width: 36px;
      height: 36px;
      border-radius: 50%;
      border: 1px solid #aaaaaa;
      background: #ffffff;
      font-size: 16px;
      box-shadow: 0 0 8px rgba(0,21,41,.2);
      cursor: pointer;
      margin-top: 14px;
      &:last-child{
        margin-bottom: 14px;
      }
      &:hover{
        color: #3471ff;
      }
    }
    .ball-list{
      position: absolute;
    }
}
</style>
